
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/ai/ui/freeTextInput/freeTextInput.scss.css.virtualfile';
        module.exports = {"input":"_input_1uoze_7"};